import * as React from "react";
const SvgFiRrSmokingBan = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-smoking-ban_svg__a)">
      <path
        fill="#062147"
        d="M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0m10 12c0 2.398-.85 4.6-2.262 6.324l-2.325-2.325h.586a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1h-4.586L5.675 4.261a9.95 9.95 0 0 1 6.324-2.262c5.514 0 10 4.486 10 10zM2 12c0-2.398.85-4.6 2.262-6.324l14.062 14.062A9.95 9.95 0 0 1 12 22C6.486 22 2 17.514 2 12m9-7a1 1 0 1 1 2 0c0 .1.262.463 1.062.691l2.423.692c1.551.444 2.514 1.446 2.514 2.616a1 1 0 1 1-2 0c0-.1-.262-.464-1.064-.692l-2.422-.692c-1.55-.442-2.514-1.444-2.514-2.615zm-3.242 7 4 4H6a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-smoking-ban_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSmokingBan;
